import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import FirmDetails from 'dibs-interiors-photos/exports/FirmDetails';

import { FirmDetailsWrapper_photoNode$key } from './__generated__/FirmDetailsWrapper_photoNode.graphql';

type Props = {
    photoNode: FirmDetailsWrapper_photoNode$key | null;
};

const FirmDetailsWrapper: FC<Props> = props => {
    const { photoNode: photoNodeRef } = props;

    const photoNode = useFragment(
        graphql`
            fragment FirmDetailsWrapper_photoNode on TradePhotosQueryOutput {
                firmName
                firmUrlLabel
                firmProfileIcon
                projectName
                projectUrl
                photo {
                    caption
                }
            }
        `,
        photoNodeRef
    );

    const firmUrlLabel = photoNode?.firmUrlLabel || '';
    const profileLink = `/design-firms/${firmUrlLabel}/`;

    return (
        <FirmDetails
            firmName={photoNode?.firmName || ''}
            firmProfileImage={photoNode?.firmProfileIcon || ''}
            profileLink={profileLink}
            projectLink={photoNode?.projectUrl || ''}
            projectName={photoNode?.projectName || ''}
            caption={photoNode?.photo?.caption || ''}
        />
    );
};

export default FirmDetailsWrapper;
